export default __webpack_public_path__ + "static/media/rogen.aaf4e1a4.gif";